export default __webpack_public_path__ + "static/media/flowchart.16baaff1.png";